import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Flex,
  IconButton,
  Text,
  ToastIndicator,
} from '@valwin/facto/components';
import { ChevronDownIcon, ChevronUpIcon } from '@valwin/facto/icons';

export function InstagramShareLoadingToast() {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded((value) => !value);
  };

  return (
    <Box
      colorPalette="gray"
      position="relative"
      overflow="hidden"
      width={{ md: 'sm' }}
      background="colorPalette.50"
      borderRadius="md"
      boxShadow="sm"
      padding="4"
    >
      <Flex align="flex-start" gap="1.5">
        <ToastIndicator type="loading" />

        <Flex direction="column" flex="1" minWidth="0">
          <Text color="black" fontWeight="bold" textStyle="sm">
            {t('integrations instagram share toast loading title')}
          </Text>

          {isExpanded && (
            <Text color="fg" textStyle="sm" opacity="0.8" whiteSpace="pre-wrap">
              {t('integrations instagram share toast loading description')}
            </Text>
          )}
        </Flex>

        <IconButton
          aria-label="toggle"
          variant="ghost"
          colorPalette="gray"
          size="2xs"
          flexShrink={0}
          onClick={handleToggle}
        >
          {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
        </IconButton>
      </Flex>
    </Box>
  );
}
